const DISTRICT_DASHBOARD_BASE_URL = 'https://www.escweb.net/districtdashboard/'

export function buildDistrictDashboardUrl(sid: string): string {
  const query = new URLSearchParams({
    cid: 'tx_esc_04',
    uid: sid,
  })

  return `${DISTRICT_DASHBOARD_BASE_URL}?${query.toString()}`
}
